import { Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, } from "@chakra-ui/react";
export { Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, };
Accordion.displayName = "Accordion";
AccordionItem.displayName = "AccordionItem";
AccordionButton.displayName = "AccordionButton";
AccordionPanel.displayName = "AccordionPanel";
AccordionIcon.displayName = "AccordionIcon";
/**
 * The wrapper that provides context and focus management for all accordion items.
 *
 * It wraps all accordion items in a div for better grouping.
 */
export default Accordion;
//# sourceMappingURL=Accordion.js.map